export const loginPortalUrl =
  import.meta.env?.VITE_LOGIN_PORTAL ||
  (typeof window !== 'undefined' ? window.RUNTIME_CONFIG?.loginPortal : undefined) ||
  'https://failure.login.timelog.com'; // If you see this address something unexpected happened
